<template>
  <EditorPanel :loading-save="loadingSave" :disabled="!isValidHarmonyName" @confirm="saveSettings">
    <EditorSectionLabel :text="$t('harmony.add-colorNick')" />
    <div class="d-flex">
      <v-text-field class="mt-2" v-model="localName" type="text" color="#9BA9BD" dense :label="$t('harmony.title')"
        :rules="harmonyRules" outlined>
      </v-text-field>
      <v-btn outlined color="#00000065" class="text-black mt-2 rounded-md py-4 ml-1 btn-brush" small :loading="loadingSave"
        :disabled="loadingSave" min-width="37px" max-width="42px" min-height="40px" @click="dialogTitle = true"
        :aria-label="$t('harmony.title-font-options')">
        <v-icon center class="pa-3" aria-hidden="true">
          mdi-brush-variant
        </v-icon>
      </v-btn>
    </div>

    <v-dialog v-model="dialogTitle" max-width="500">
      <v-card class="px-4 py-8">
        <EditorSectionLabel :text="$t('harmony.fotn-options')" />
        <v-select v-model="localTitleFont" :items="fontsOptions" color="#9BA9BD" label="Selecciona el tipo de fuente"
          class="mt-2 list-fonts-input" outlined dense item-value="value" :item-text="formatText">
          <template v-slot:item="data">
            <div :class="data.item.value" class="list-fonts" style="font-size: 24px;">
              {{ data.item.fontName }} : {{ data.item.text }}
            </div>
          </template>
        </v-select>
        <div class="d-flex">
          <v-select v-model="localTitleWeight"
            :items="['100', '200', '300', '400', '500', '600', '700', '800', '900']" type="number"
            :label="$t('harmony.platform-newWeight')" outlined dense class="mt-2 list-weight-input mr-2"></v-select>

          <v-text-field v-model="localTitleSize" type="number" :label="$t('harmony.platform-newSize')" outlined min="32"
            max="65" dense class="mt-2 list-weight-input"></v-text-field>
        </div>

        <v-btn outlined color="#8e84c0" class="text-black mt-2 py-4 px-10" small :loading="loadingSave"
          :disabled="loadingSave" @click="saveSettings" :aria-label="$t('harmony.save-font-options')">
          <v-icon center aria-hidden="true">
            mdi-check-bold
          </v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <v-color-picker v-model="localTitleColor" dot-size="25" hide-inputs hide-mode-switch swatches-max-height="200">
    </v-color-picker>
  </EditorPanel>
</template>

<script>
import EditorPanel from './EditorPanel.vue'
import EditorSectionLabel from './shared/EditorSectionLabel.vue'
export default {
  name: 'EditorTitlePanel',
  components: { EditorPanel, EditorSectionLabel },
  props: {
    harmony: {
      type: Object,
      required: true
    },
    siteSetting: {
      type: Object,
      required: true
    },
    loadingSave: {
      type: Boolean,
      default: false
    },
    fontsOptions: {
      type: Array,
      default: () => []
    },
    harmonyRules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogTitle: false,
      localName: this.harmony.name || '',
      localTitleFont: this.siteSetting.profile.title_font?.font || 'font-rubik',
      localTitleWeight: this.siteSetting.profile.title_font?.weight || '700',
      localTitleSize: this.siteSetting.profile.title_font?.size || '32',
      localTitleColor: this.siteSetting.profile.title_color || '#373535'
    }
  },
  computed: {
    isValidHarmonyName() {
      return this.harmonyRules.every(rule => rule(this.localName) === true)
    }
  },
  watch: {
    'harmony.name'(newVal) {
      this.localName = newVal || ''
    },
    'siteSetting.profile.title_font': {
      handler(newVal) {
        this.localTitleFont = newVal?.font || 'font-rubik'
        this.localTitleWeight = newVal?.weight || '700'
        this.localTitleSize = newVal?.size || '32'
      },
      deep: true
    },
    'siteSetting.profile.title_color'(newVal) {
      this.localTitleColor = newVal || '#373535'
    }
  },
  methods: {
    saveSettings() {
      this.$emit('update:name', this.localName)
      this.$emit('update:title-font', {
        font: this.localTitleFont,
        weight: this.localTitleWeight,
        size: this.localTitleSize
      })
      this.$emit('update:title-color', this.localTitleColor)
      this.$emit('save-nick-settings')
      this.dialogTitle = false
    },
    formatText(item) {
      return `${item.fontName} : ${item.text}`
    }
  }
}
</script>

<style scoped>
@import './editor-panel.css';

.list-fonts {
  max-width: 280px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.list-fonts-input {
  max-width: 320.28px;
}

.list-weight-input {
  width: 90px !important;
}
</style>
